import React, { useEffect } from "react";
import { HStack, Pressable, Text, Box } from "native-base";
import * as AV from "../../../AVCore/AVCore";
import { ILink } from "../../../AVCore/Interfaces/Link";
import { Link } from "../../../AVCore/Link";
import { IAVEntity } from "../../../AVCore/Interfaces/AVEntity";
import EntityProfilePic from "../../../components/common/EntityProfilePic";
import { Loc } from "../../../App/Loc";
import {
  MoreHorizontalIcon,
  TranslationIcon,
} from "../../../assets/icons/icon-assets";
import AVCancel from "../../../components/common/AVCancel";
import { ActivityIndicator } from "react-native";
import ManageConvoPopup from "../conversations/ManageConversation";
import { SignalRService } from "../../../AVCore/SignalR";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../types_interface/RootState";
import { setIsConvoScreenOpen } from "../../../Redux/Actions/userActions";

const ChatHeader = ({
  isHuddleChatTab,
  isOpenConvo,
  convo,
  handleNavigateToProfile,
  handleuserRedirect,
  profile,
  Setprofile,
  handleGetEntityLink,
  entitydatalist,
  convoSubject,
  fetchloading,
  setShowManageConvoPopup,
  showManageConvoPopup,
  setConvos,
  setIsConvoData,
  setShowEmoji,
  setConvoLoading,
  setMdlCreateConvoVisible,
  setIsOpenConvo,
  toFK,
  settoFK,
  setShowSearch,
  setShowConvoListModal,
  setMdlConvoVisible,
}) => {
  const currentUser = useSelector((state: RootState) => state.user.user[0]);
  const userconvo = useSelector((state: RootState) => state.convo.convo[0]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (profile?.id?.length > 0 || convoSubject?.trim()?.length > 0) {
      setIsOpenConvo(true);
    }
  }, [profile]);

  return (
    <>
      {!isHuddleChatTab ? (
        <HStack
          justifyContent="space-between"
          width="100%"
          alignItems="center"
          px={4}
          py={3}
          borderBottomWidth={1}
          borderBottomColor="gray.100"
        >
          <HStack flex={1} space={3} alignItems="center">
            {isOpenConvo ? (
              convo?.subject?.trim()?.length === 0 ? (
                <>
                  <Pressable onPress={() => handleuserRedirect(profile)}>
                    <EntityProfilePic
                      width={38}
                      height={38}
                      link={
                        (entitydatalist?.find(
                          (x: IAVEntity) => x?.id == profile?.id,
                        )
                          ? AV.AVEntity.getLink(
                              entitydatalist.find(
                                (x: IAVEntity) => x?.id == profile?.id,
                              ) as IAVEntity,
                            )
                          : profile) as ILink
                      }
                    />
                  </Pressable>
                  <HStack>
                    <Pressable onPress={handleNavigateToProfile}>
                      <Text
                        fontSize="24px"
                        fontWeight="600"
                        maxWidth="300px"
                        numberOfLines={1}
                        ellipsizeMode="tail"
                        color="black"
                      >
                        {profile?.title}
                      </Text>
                    </Pressable>
                  </HStack>
                </>
              ) : (
                <Text
                  fontSize="24px"
                  fontWeight="600"
                  maxWidth="300px"
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  color="black"
                >
                  {convoSubject}
                </Text>
              )
            ) : (
              <Text
                fontSize="24px"
                fontWeight="600"
                maxWidth="300px"
                numberOfLines={1}
                ellipsizeMode="tail"
                color="black"
              >
                {Loc.currentLang.menu.createNew}
              </Text>
            )}

            {fetchloading && <ActivityIndicator size={30} color="green" />}
          </HStack>

          <HStack space={4} alignItems="center">
            {isOpenConvo && (
              <Box position="relative">
                <Pressable
                  onPress={() => setShowManageConvoPopup(true)}
                  _hover={{ backgroundColor: "gray.100" }}
                  p={2}
                  rounded="full"
                >
                  <MoreHorizontalIcon size="18px" color="gray.700" />
                </Pressable>

                {showManageConvoPopup && (
                  <ManageConvoPopup
                    onClose={() => setShowManageConvoPopup(false)}
                    convo={convo}
                    currentUser={currentUser}
                    toFK={toFK}
                    setToFK={settoFK}
                    userConvo={userconvo}
                    setConvos={setConvos}
                    setShowConvoListModal={setShowConvoListModal}
                    setMdlConvoVisible={setMdlConvoVisible}
                    setMdlCreateConvoVisible={setMdlCreateConvoVisible}
                    setConvoLoading={setConvoLoading}
                    setIsOpenConvo={setIsOpenConvo}
                  />
                )}
              </Box>
            )}

            <AVCancel
              callback={async () => {
                await SignalRService.lostFocus();
                setConvos([]);
                Setprofile([]);
                setIsConvoData("");
                dispatch(
                  setIsConvoScreenOpen({ isOpen: false, convoId: null }),
                );
                setMdlCreateConvoVisible(false);
                setIsOpenConvo(false);
                setConvos("");
                setShowEmoji(false);
                setConvoLoading(false);
                setShowSearch(false);
              }}
              color={undefined}
              size={undefined}
            />
          </HStack>
        </HStack>
      ) : (
        <>
          {fetchloading && <ActivityIndicator size={30} color="green" />}
          <HStack />
        </>
      )}
    </>
  );
};

export default ChatHeader;
